export default "__VITE_ASSET__CNrLXA45__"